module.exports = __webpack_public_path__ + "erik-lucatero-2.jpg?2051e0e847124c536df9c01a3f672032";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faces/erik-lucatero-2.jpg
// module id = 238
// module chunks = 0